import React from "react";
import { Check } from "lucide-react";

// Shared pipeline / status tile used by every Experience Mode flow
// (EOB → ERA, Single document → one claim, …). One header row + a list of
// sub-steps. States: idle | run (amber, spinner) | done (green, check).
export default function PipelineTile({ icon: Icon, title, done, run, rightSlot, subs = [], innerRef }) {
  return (
    <div ref={innerRef} className={`rounded-[13px] border mb-2.5 overflow-hidden transition-colors ${
      done ? "border-[rgba(52,199,89,.25)] bg-[rgba(52,199,89,.045)]"
        : run ? "border-black/[.16] bg-white/50 shadow-[0_4px_16px_rgba(0,0,0,.06)]"
        : "border-black/[.07] bg-white/50"
    }`}>
      <div className="flex items-center gap-2.5 px-3.5 py-2.5">
        <div className={`w-[30px] h-[30px] rounded-[9px] flex items-center justify-center flex-shrink-0 border transition-colors ${
          done ? "bg-[var(--green,#34c759)] border-[var(--green,#34c759)] text-white"
            : run ? "bg-[rgba(255,159,10,.14)] border-[rgba(255,159,10,.3)] text-[var(--amber-deep,#a15c00)]"
            : "bg-black/[.05] border-black/[.07] text-[var(--gray1)]"
        }`}>
          {Icon ? <Icon size={15} strokeWidth={1.8} /> : null}
        </div>
        <div className="text-[12.5px] font-bold text-[var(--ink)]">{title}</div>
        {rightSlot != null ? <div className="ml-auto">{rightSlot}</div> : null}
      </div>
      {subs.length ? (
        <div className="px-3.5 pb-2.5">
          {subs.map((s, i) => <PipelineSub key={s.key ?? i} {...s} />)}
        </div>
      ) : null}
    </div>
  );
}

function PipelineSub({ title, sub, done, run, children }) {
  return (
    <div className={`flex items-start gap-3 py-1.5 pl-4 ml-3.5 border-l-2 border-black/[.07] transition-opacity ${
      run ? "opacity-100" : done ? "opacity-90" : "opacity-45"
    }`}>
      <span className={`w-[15px] h-[15px] rounded-full flex-shrink-0 mt-0.5 flex items-center justify-center border-[1.6px] box-border ${
        done ? "bg-[var(--green,#34c759)] border-[var(--green,#34c759)] text-white"
          : run ? "border-[var(--amber-deep,#a15c00)] border-t-transparent animate-spin"
          : "border-[var(--gray4,#c7c7cc)]"
      }`}>
        {done ? <Check size={9} /> : null}
      </span>
      <div className="min-w-0">
        <div key={title} className={`text-[11.5px] leading-[1.4] font-semibold ${run ? "text-[var(--ink)]" : "text-[var(--ink2)]"}`}>
          {title}
        </div>
        {sub ? (
          <div className={`grid transition-[grid-template-rows] duration-300 ease-out ${run ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
            <div className="overflow-hidden">
              <div key={sub} className="text-[10px] text-[var(--gray2)] leading-[1.4] pt-0.5">{sub}</div>
            </div>
          </div>
        ) : null}
        {children}
      </div>
    </div>
  );
}
